<style lang="less">
@import './less/registered.less';

.regiserpage {

    .iview .ivu-input,
    .iview .ivu-select-selection {
        background-color: #102E46 !important;
    }
}
</style>
<template>
<div class="regiserpage" :style="{backgroundImage:'url(' + url.url_1 + ')',backgroundSize:'100% 100%'}">
    <div class=" display_column" style="height: 560px;width: 500px;padding-bottom:10px;color:#0CDAD9;position:relative;">
        <div class="registered_head display_row_js_ac dispaly_flex00" style="border: none;">
            <div style="margin-left: 20px;font-size: 18px;">
                <span>注册用户</span>
            </div>
            <div style="margin-top: 40px;">
                <img @click="click_gb()" style="width: 16px;" src="./images/logincloseimg2.png">
            </div>
        </div>
        <div class="registered_end display_column_ac dispaly_flex11">
            <div class="registered_end_2 display_row_ac dispaly_flex00" style=" position: relative;">
                <span class="registered_end_2_span">所属单位：</span>
                <Select v-model="name.ssdw" style="width: 300px" placeholder="所属单位" filterable placement="bottom">
                    <Option v-for="item in dw" :value="item.ID" :key="item.ID">{{ item.DWMC }}</Option>
                </Select>
                <div style="position: absolute;top: 13px;right: -36px;cursor:pointer;" @click="showunit"><span style="float: right;">添加</span></div>
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">用户名：</span>
                <Input v-model="name.yhm" placeholder="用户名" style="width: 300px" />
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">密码：</span>
                <Input v-model="name.mm" type="password" placeholder="密码" autocomplete="new-password" style="width: 300px" />
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">确认密码：</span>
                <Input v-model="name.zmm" type="password" placeholder="确认密码" style="width: 300px" />
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">姓名：</span>
                <Input v-model="name.xm" placeholder="姓名" style="width: 300px" />
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">性别：</span>
                <div style="width: 300px">
                    <RadioGroup v-model="name.xb">
                        <Radio label="男"></Radio>
                        <Radio label="女"></Radio>
                    </RadioGroup>
                </div>
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">出生日期：</span>
                <DatePicker v-model="name.rq" type="date" placeholder="出生日期" style="width: 300px" :clearable="false"></DatePicker>
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">电话：</span>
                <Input v-model="name.dh" placeholder="电话" style="width: 300px" />
            </div>
            <div class="registered_end_2 display_row_ac dispaly_flex00">
                <span class="registered_end_2_span">邮箱：</span>
                <Input v-model="name.yq" placeholder="邮箱" style="width: 300px" />
            </div>
        </div>
        <div class="registered_save display_row_jc_ac dispaly_flex00" style="border: none;">
            <button @click="checkadministrator()">注册</button>
        </div>
    </div>
</div>
</template>

<script>
import bus from "../../app/event";
export default {
    components: {},
    data() {
        return {
            judge: false,
            url: {
                url_1: "./static/img/1.d6d644a.png",
            },
            name: {
                yhm: "",
                mm: "",
                xm: "",
                zmm: "",
                xb: "男",
                rq: "",
                dh: "",
                yq: "",
                ssdw: "",
            },
            dw: []
        };
    },
    watch: {},
    methods: {

        showunit: function () {
            bus.$emit('showunit_login', 2);
        },
        click_gb: function () {
            this.cz();
            bus.$emit('showunit_login', 0);
        },
        cz: function () {
            this.name = {
                yhm: "",
                mm: "",
                xm: "",
                zmm: "",
                xb: "男",
                rq: "",
                dh: "",
                yq: "",
                ssdw: "",
            };
        },
        checkadministrator: function () {
            let unitcode=this.name.ssdw;
            let data = {
                FILED: 'ID',
                TABLENAME: 'SYS_USER',
                SQLWHERE: `ssdw='${unitcode}' and aothor_id=1 and isadmin=1`
            }
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=generalsql", data
                )
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.length == 0) {
                            this.checkUser();
                        } else {
                            this.$Message.warning('一个单位只能有一位管理员');
                        }
                    } else {
                        this.$Message.warning('校验失败')
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        //验证用户是否存在
        checkUser: function () {
            if (this.name.yhm == "") {
                this.$Message.warning('请输入用户名!');
                return
            }
            this.$http.post(
                    appurl.ip + "/ylkjservice/services/hander.ashx?action=IsExitUser", {
                        UserCode: this.name.yhm,
                    }
                )
                .then(res => {
                    if (res.status == 200) {
                        if (res.data.success == 'true') {
                            this.name.yhm = "";
                            this.$Message.warning('该账号已存在!');
                        } else {
                            this.click_save();
                        }
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "访问失败！",
                        duration: 3
                    });
                })
        },
        click_save: function () {
            var _this = this;

            if (this.name.mm == "") {
                this.$Message.warning('请输入密码!');
                return
            }
            if (this.name.zmm == "") {
                this.$Message.warning('请输入确认密码!');
                return
            }
            if (this.name.zmm != this.name.mm) {
                this.$Message.warning('两次密码不一致, 请重新输入!');
                return
            }
            if (this.name.xm == "") {
                this.$Message.warning('请输入姓名!');
                return
            }
            if (this.name.rq == "") {
                this.$Message.warning('请选择出生日期!'); //this.name.rq.Format("yyyy-MM-dd")
                return
            }
            /*  if (this.name.dh == "") {
                 this.$Message.warning('请输入电话!');
                 return
             } */

            /* if (this.name.yq != "") {
                this.$Message.warning('请输入邮箱!');
                return
            } */
            if (this.name.ssdw == "") {
                this.$Message.warning('请选择所属单位!');
                return
            }
            if (this.judge == true) {
                return
            }
            _this.judge = true;
            this.$http
                .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=saveadminuser", {
                    USERCODE: this.name.yhm,
                    USERNAME: this.name.xm,
                    USERPASSWORD: this.name.mm,
                    SEX: (this.name.xb == "男") ? (0) : (1),
                    PHONE: this.name.dh,
                    EMAIL: this.name.yq,
                    SSDW: this.name.ssdw,
                    DATEOFBIRTH: (this.name.rq == "") ? ("") : (this.name.rq.Format("yyyy-MM-dd")),

                })
                .then(response => {
                    _this.judge = false;
                    if (response.data.success == "true") {
                        _this.cz();
                        _this.$Message.success('注册成功,等待园林局审批!');
                        _this.$parent.$parent.$children[0].registered_flog = false;
                    } else {
                        _this.$Message.warning({
                            content: "注册失败!",
                            duration: 3
                        });
                    }
                    bus.$emit('showunit_login', 0); //返回登陆界面
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "请求失败",
                        duration: 3
                    });
                });
        },
        //查询单位信息
        query_dw() {
            var _this = this;
            this.$http
                .post(appurl.ip + "/ylkjservice/services/hander.ashx?action=listorg", {})
                .then(response => {
                    if (response.status == 200) {
                        _this.dw = [];
                        response.data.forEach(el=>{
                            el.DWMC!==''?_this.dw.push(el):null;
                        })
                    } else {
                        this.$Message.warning({
                            content: "获取单位信息失败",
                            duration: 3
                        });
                    }
                })
                .catch(error => {
                    this.$Message.warning({
                        content: "请求失败",
                        duration: 3
                    });
                });
        },
    },
    mounted() {
        this.query_dw();
        bus.$on('refreshreg', this.query_dw)
    },
    beforeDestroy() {
        bus.$off('refreshreg');
    },
    destoryed: function () {},
};
</script>



// WEBPACK FOOTER //
// registered.vue?d55ddb7e